const init = function () {
    const pageId = document.querySelector('[data-page="auto_test"]');

    if (!pageId) {
        return;
    }

    const routeTest = pageId.dataset.routeTest;
    const routeDetails = pageId.dataset.routeDetails;
    const routesGrid = document.querySelector('[data-routesGrid]');
    const loadRoutesBtn = document.querySelector('[data-loadRoutesBtn]');
    const startBtn = document.querySelector('[data-startBtn]');
    const delayInput = document.querySelector('[data-delayInput]');
    const progressText = document.querySelector('[data-progressText]');
    const modalEl = document.getElementById('routeTestDetailsModal');

    if (!routesGrid || !loadRoutesBtn || !startBtn || !delayInput || !progressText || !modalEl || !window.bootstrap?.Modal) {
        return;
    }

    const modal = window.bootstrap.Modal.getOrCreateInstance(modalEl);
    const loadingEl = document.getElementById('routeTestDetailsLoading');
    const contentEl = document.getElementById('routeTestDetailsContent');
    const routeNameEl = document.getElementById('routeTestDetailsName');
    const routeUrlEl = document.getElementById('routeTestDetailsUrl');
    const statusEl = document.getElementById('routeTestDetailsStatus');
    const hashEl = document.getElementById('routeTestDetailsHash');
    const errorEl = document.getElementById('routeTestDetailsError');

    let routes = [];
    let boxes = [];
    let activeBox = null;

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    function getStatusClass(status) {
        if (status >= 200 && status < 300) return 'status-2xx';
        if (status >= 300 && status < 400) return 'status-3xx';
        if (status >= 400 && status < 500) return 'status-4xx';
        if (status >= 500) return 'status-5xx';

        return 'status-error';
    }

    function createHealthCheckUrl(baseUrl, healthCheckId) {
        const url = new URL(baseUrl, window.location.origin);

        url.searchParams.set('health_check_id', healthCheckId);

        return url.toString();
    }

    function createHealthCheckId() {
        if (window.crypto?.randomUUID) {
            return window.crypto.randomUUID();
        }

        return `hc-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    }

    function setActiveBox(box) {
        if (activeBox) {
            activeBox.classList.remove('is-active');
        }

        activeBox = box;

        if (activeBox) {
            activeBox.classList.add('is-active');
        }
    }

    function setModalLoadingState() {
        loadingEl.textContent = 'Загрузка данных...';
        loadingEl.classList.remove('d-none');
        contentEl.classList.add('d-none');
    }

    function getStatusBadgeClass(status) {
        if (status >= 200 && status < 300) return 'badge text-bg-success';
        if (status >= 300 && status < 400) return 'badge text-bg-warning';
        if (status >= 400 && status < 500) return 'badge text-bg-danger';
        if (status >= 500) return 'badge text-bg-dark';

        return 'badge text-bg-secondary';
    }

    function setStatusBadge(status) {
        const normalizedStatus = Number(status);

        statusEl.className = getStatusBadgeClass(normalizedStatus);
        statusEl.textContent = status ?? 'Не запускался';
    }

    function renderModalDetails(data) {
        routeNameEl.textContent = data.route_name || 'Без имени';
        routeUrlEl.textContent = data.route_url || data.route_uri || '-';
        setStatusBadge(data.status_code);
        hashEl.textContent = data.health_check_id || '-';

        if (data.fetch_error) {
            errorEl.textContent = data.fetch_error;
        } else if (data.error_log?.error_text) {
            errorEl.textContent = data.error_log.error_text;
        } else {
            errorEl.textContent = 'Запись ошибки не найдена.';
        }

        loadingEl.classList.add('d-none');
        contentEl.classList.remove('d-none');
    }

    async function openRouteDetails(index) {
        const route = routes[index];
        const box = boxes[index];

        if (!route || !box) {
            return;
        }

        setActiveBox(box);
        setModalLoadingState();
        modal.show();

        try {
            const params = new URLSearchParams();

            if (route.name) {
                params.set('name', route.name);
            }

            params.set('uri', route.resolved_uri || route.uri || '');

            if (route.last_status !== null && route.last_status !== undefined) {
                params.set('status', String(route.last_status));
            }

            if (route.health_check_id) {
                params.set('health_check_id', route.health_check_id);
            }

            if (route.fetch_error) {
                params.set('fetch_error', route.fetch_error);
            }

            const response = await fetch(`${routeDetails}?${params.toString()}`, {
                method: 'GET',
                cache: 'no-store',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const data = await response.json();

            renderModalDetails(data);
        } catch (error) {
            routeNameEl.textContent = route.name || 'Без имени';
            routeUrlEl.textContent = route.url || route.resolved_uri || route.uri || '-';
            setStatusBadge(route.last_status);
            hashEl.textContent = route.health_check_id || '-';
            errorEl.textContent = `Не удалось загрузить детали: ${error.message}`;
            loadingEl.classList.add('d-none');
            contentEl.classList.remove('d-none');
        }
    }

    function resetRouteState(route) {
        route.last_status = null;
        route.health_check_id = null;
        route.fetch_error = null;
    }

    function updateBoxTitle(box, route) {
        const title = [
            route.name || route.uri,
            route.url || route.resolved_uri || route.uri,
        ];

        if (route.has_required_params) {
            title.push('Пропущено: есть обязательные параметры');
        }

        if (route.last_status !== null && route.last_status !== undefined) {
            title.push(`Status: ${route.last_status}`);
        }

        if (route.fetch_error) {
            title.push(route.fetch_error);
        }

        box.title = title.join('\n');
    }

    async function loadRoutes() {
        routesGrid.innerHTML = '';
        progressText.textContent = '0 / 0';
        startBtn.disabled = true;
        setActiveBox(null);

        const response = await fetch(routeTest, {
            method: 'GET',
            cache: 'no-store',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
        routes = await response.json();

        boxes = routes.map((route, index) => {
            const box = document.createElement('button');

            box.type = 'button';
            box.className = 'route-box';
            box.dataset.routeIndex = String(index);

            resetRouteState(route);
            updateBoxTitle(box, route);

            if (route.has_required_params) {
                box.classList.add('status-skip');
            }

            box.addEventListener('click', () => {
                openRouteDetails(index);
            });

            routesGrid.appendChild(box);

            return box;
        });

        progressText.textContent = `0 / ${routes.length}`;
        startBtn.disabled = false;
    }

    async function startCheck() {
        await loadRoutes();
        startBtn.disabled = true;
        loadRoutesBtn.disabled = true;

        const delay = Number(delayInput.value || 0);
        let checked = 0;

        for (let i = 0; i < routes.length; i++) {
            const route = routes[i];
            const box = boxes[i];

            if (route.has_required_params) {
                checked++;
                progressText.textContent = `${checked} / ${routes.length}`;
                continue;
            }

            route.health_check_id = createHealthCheckId();
            route.fetch_error = null;
            route.last_status = null;

            try {
                const response = await fetch(createHealthCheckUrl(route.url, route.health_check_id), {
                    method: 'GET',
                    redirect: 'manual',
                    cache: 'no-store',
                    headers: {
                        'X-Route-Health-Check': '1',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                route.last_status = response.status;
                box.classList.add(getStatusClass(response.status));
            } catch (error) {
                route.fetch_error = error.message || 'Ошибка fetch';
                box.classList.add('status-error');
            }

            updateBoxTitle(box, route);

            checked++;
            progressText.textContent = `${checked} / ${routes.length}`;

            if (delay > 0) {
                await sleep(delay);
            }
        }

        startBtn.disabled = false;
        loadRoutesBtn.disabled = false;
    }

    modalEl.addEventListener('hidden.bs.modal', () => {
        setActiveBox(null);
    });

    loadRoutesBtn.addEventListener('click', loadRoutes);
    startBtn.addEventListener('click', startCheck);
};

export default {init};
